import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertTriangle, Loader2 } from "lucide-react";

const fmt = (d) => (d ? new Date(`${d.slice(0, 10)}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");

export const EtaConfirmDialog = ({ detail, onConfirm, onCancel, saving }) => {
  const [reason, setReason] = useState("");
  if (!detail) return null;
  return (
    <Dialog open onOpenChange={(v) => { if (!v) onCancel(); }}>
      <DialogContent className="border-border bg-white sm:max-w-md" data-testid="eta-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-2xl font-medium text-charcoal"><AlertTriangle className="h-5 w-5 text-amber-700" /> Confirm ETA override</DialogTitle>
          <DialogDescription className="text-sm text-warmgrey">{detail.message} Threshold: {detail.threshold_days} days. An earlier ETA is not automatically wrong — confirm only if you have verified it.</DialogDescription>
        </DialogHeader>
        <ul className="space-y-2">
          {detail.differences.map((d) => (
            <li key={d.field} className="rounded-md border border-amber-300 bg-amber-50 p-3 text-xs text-amber-900" data-testid={`eta-diff-${d.field}`}>
              <span className="font-semibold uppercase tracking-wider">{d.field === "eta_carrier" ? "Miami port ETA" : "Warehouse ETA"}</span>: you entered <strong>{fmt(d.entered)}</strong>, {Math.abs(d.days)} day{Math.abs(d.days) === 1 ? "" : "s"} {d.direction} than the {d.reference_label} <strong>{fmt(d.reference)}</strong>.
            </li>
          ))}
        </ul>
        <div className="space-y-2">
          <Label className="text-xs font-semibold uppercase tracking-wider text-warmgrey">Reason for override *</Label>
          <Input required minLength={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. broker confirmed by phone on Oct 12" data-testid="eta-override-reason" className="h-11 bg-white" />
        </div>
        <div className="flex gap-3">
          <Button variant="outline" onClick={onCancel} disabled={saving} data-testid="eta-confirm-cancel" className="h-11 flex-1 border-limestone">Go back</Button>
          <Button onClick={() => onConfirm(reason)} disabled={saving || reason.trim().length < 3} data-testid="eta-confirm-save" className="h-11 flex-1 bg-terracotta text-white hover:bg-terracotta-hover">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Confirm and save override"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
